import React, { useEffect, useState } from "react";
import "./mostPopular.scss";

import INNER_CHAOS_TITLE from "../../../assets/img/bottle/INNER_CHAOS_TITLE.png";
import VENGEANCE_TITLE from "../../../assets/img/bottle/VENGEANCE_TITLE.png";
import { Link } from "react-router-dom";
import productStore from "../../../store/productStore";
import { PRODUCT_IMAGE_URL } from "../../../constant";
import categoryStore from "../../../store/categoryStore";

const MostPopular = () => {
  const ProductStore = productStore();
  const [customerFavorites, setCustomerFavorites] = useState([]);

  useEffect(() => {
    if (ProductStore.mProduct) {
      const products = ProductStore.mProduct.filter(
        (product) =>
          product.productName === "VENGEANCE" ||
          product.productName === "OCEAN BAY"
      );

      setCustomerFavorites(products);
    }
  }, [ProductStore.mProduct]);

  return (
    <div className="mostPopular">
      <h2 className="header">Customer's Favorites</h2>

      <div className="popular-cards">
        {ProductStore.product &&
          customerFavorites.map((item, index) => {
            return <LeftProduct product={item} key={index} />;
          })}
      </div>
    </div>
  );
};

const LeftProduct = ({ product }) => {
  const CategoryStore = categoryStore();
  const [categoryName, setCategoryName] = useState();

  useEffect(() => {
    if (CategoryStore.category) {
      CategoryStore.category.filter((category) => {
        return (
          category._id === product.categoryID &&
          setCategoryName(category.categoryName)
        );
      });
    }
  }, []);

  return (
    <div className="card">
      <div className="left">
        <div className="container">
          <h3>{product.productName}</h3>
          <p>{product.productSubDescription}</p>
          <Link
            to={`/${categoryName}/${product.productName}/${product._id}/details`}
            className="link"
          >
            Discover {product.productName}
            <div className="bottom-border"></div>
          </Link>
        </div>
      </div>
      <div className="right">
        <img src={`${PRODUCT_IMAGE_URL}${product.productImages[1]}`} alt="" />
      </div>
    </div>
  );
};
const RightProduct = ({ product }) => {
  const CategoryStore = categoryStore();
  const [categoryName, setCategoryName] = useState();

  useEffect(() => {
    if (CategoryStore.category) {
      CategoryStore.category.filter((category) => {
        return (
          category._id === product.categoryID &&
          setCategoryName(category.categoryName)
        );
      });
    }
  }, []);

  return (
    <div className="card">
      <div className="right">
        <img src={`${PRODUCT_IMAGE_URL}${product.productImages[0]}`} alt="" />
      </div>
      <div className="left">
        <div className="container">
          <h3>{product.productName}</h3>
          <p>{product.productSubDescription}</p>
          <Link
            to={`/${categoryName}/${product.productName}/${product._id}/details`}
            className="link"
          >
            Discover {product.productName}
            <div className="bottom-border"></div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MostPopular;
